import "./Header.css";

export function Header() {
    return <div className="header-container"></div>;
}
